
<script setup>

import Button from './button.vue'

</script>

<template>

  <div class="bg-red rounded-md border-2 border-white">

    <div class="flex flex-col md:flex-row md:justify-between md:items-center px-6 py-4 gap-6">

      <div class="flex items-center gap-4">

        <div class="hidden md:block min-w-9 min-h-9">

          <img src="../../images/icons/white-alert.svg">

        </div>

        <div class="flex flex-col gap-2 sm:gap-0">

          <p class="font-bold text-lg leading-5">Outbreak Alert&colon; Mycoplasma Pneumonia</p>

          <p class="text-sm xl:text-base">The CDC has flagged a significant spike in cases of Mycoplasma pneumoniae since late spring, which continue to remain high.</p>

        </div>

      </div>

      <div>

        <Button size="sm" class="bg-white text-blue-primary hover:bg-neutral-200 block whitespace-nowrap">
          
          <a data-use-tracking href="">take action</a>
        
        </Button>

      </div>

    </div>

  </div>

</template>